export default [
    {
        path: '/vehicle-brands',
        name: 'vehicle-brands',
        meta: {
            layout: 'dashboard'
        },
        component: () => import('VIEWS/Catalogs/VehicleBrands.vue')
    }
]